import React from "react";
import { trackstarList } from "variables/trackstarList";

export const displayProductChannelIcon = (channel: string, className?: string) => {
    const list = [
        ...trackstarList,
        //for testing purposes
        {
            imageSrc:
                "https://storage.googleapis.com/heysynth_files/synth_webapp/Gmail_icon__2020_2_61_qfz3de.svg",
            imageName: "Sandox",
            title: "Sandbox",
            content:
                "Connecting your Sandbox account allows Synth to get and analyze supply chain-related information, improving stock visibility and warehouse efficiency.",
            connected: false,
            trackstarIntegration: "sandbox",
        },
    ];
    const integration = list?.find((item) => item?.trackstarIntegration === channel?.split(".")[1]);
    switch (channel?.toLowerCase()) {
        case "quickbooks":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/quickbooksIcon_poqahg.svg"
                    alt="quickbooks"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "quickbooks desktop":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/quickbooksIcon_poqahg.svg"
                    alt="quickbooks desktop"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "sps-commerce":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/sps_commerce_v0uhiz.png"
                    alt="sps commerce"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "shopify":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/shopifyIcon_qelbea.svg"
                    alt="shopify"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "amazon":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/amazon_ciygng.svg"
                    alt="amazon"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "gmail":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/gmail_1_zya4ai.svg"
                    alt="gmail"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "gmail-full":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/gmail_logo_dtfhgg.jpg"
                    alt="gmail"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "microsoft":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/microsoft-outlook_owky6v.png"
                    alt="microsoft"
                    className={`w-6 h-6 ${className}`}
                />
            );
        case "outlook":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/microsoft-outlook_owky6v.png"
                    alt="outlook"
                    className={`w-6 h-6 ${className}`}
                />
            );

        case `trackstar.${integration?.trackstarIntegration}`:
            return (
                <img
                    src={integration?.imageSrc}
                    alt={integration?.title}
                    className={`w-6 h-6 ${className}`}
                />
            );
        default:
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/synthIconOnly_rcj7zd.svg"
                    alt="synth"
                    className={`w-6 h-6 ${className}`}
                />
            );
    }
};
